class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M13.614 11.809 10 6.837V2h1V1H5v1h1v4.837L2.383 11.81A2.01 2.01 0 0 0 4.009 15h7.98a2.01 2.01 0 0 0 1.625-3.191ZM7 7.16V2h2v5.16L10.334 9H5.663L7 7.16Zm4.989 6.837h-7.98a1.009 1.009 0 0 1-.818-1.603l1.743-2.397h6.129l1.743 2.397c.223.309.254.715.083 1.052-.172.34-.52.551-.9.551Z"></path></svg>';
  }
}
const e = "pi-chemical-manager";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
